import React, { useCallback } from 'react';
import { TSession } from './Sessions';
import { withRouter, RouteComponentProps } from 'react-router';
import { Tooltip } from '@material-ui/core';
import { Visibility } from '@material-ui/icons';
import { LinkDiv } from './SessionPrepareButton';

interface Props extends RouteComponentProps {
  session: TSession;
}

const SessionVisualizeButton: React.FunctionComponent<Props> = ({ session, history }) => {
  const onClick = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      history.push('/session/visualize/' + session.id);
    },
    [session, history]
  );

  return(
    <LinkDiv onClick={onClick}>
      <Tooltip title="Visualize">
        <Visibility color="secondary" />
      </Tooltip>
    </LinkDiv>
  );
};

export default withRouter(SessionVisualizeButton);
